export enum FleetTableRowStatusEnum {
  ACTIVE = 'success',
  STOPED = 'warning',
}
